export const qrRedirectQueryKeys = {
  _base: () => ["qrRedirects"],
  all: () => [
    ...qrRedirectQueryKeys._base(),
  ],
};
